(($)=>{

    "use strict";

    const $root = $('.where-to-find');

    if($root.length < 1) { return; }
    const $sliderButtons = $('.slider-buttons', $root);
    const $tabbedSlider = $('[data-filtered-slider]', $root);
    const $slides = $tabbedSlider.children();

    // lets set slide id for tab, so clicking on button will show first slide in category.
	let oldTabId = null;
	$slides.each(function(elIndex, el){
        const tab_id = $(el).attr('data-tab');

		if(tab_id !== oldTabId){
            oldTabId = tab_id;

			$(`a[data-tab="${tab_id}"]`, $sliderButtons).attr('data-slide-to', elIndex);

		}
	});

    $tabbedSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
		prevArrow : $('.slider-nav a.prev', $root),
        nextArrow : $('.slider-nav a.next', $root),
		autoplay: true
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){

        const $nextSlide = $slides.eq(nextSlide);
        const tab_id = $nextSlide.attr('data-tab');
        const $btnToActivate = $(`a[data-tab="${tab_id}"]`, $sliderButtons);

        $('a', $sliderButtons).not($btnToActivate).removeClass('active');

        $btnToActivate.addClass('active');

    });

	$('a', $sliderButtons).click(function(e){
		// button's active state is managed in slider's state change.
		e.preventDefault();

		const slideTo = $(this).attr('data-slide-to');

        $tabbedSlider.slick('slickGoTo', slideTo);


	});

	$sliderButtons.slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: false,
		arrows: false,
		variableWidth: true,
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});




	


	function updateMaxHeight() {
		var maxHeight = 0;
		$('.companies-slider .company').each(function(index, el) {
			$(el).height();
			if ( maxHeight < $(el).height() ) maxHeight = $(el).height();
		});

		$('.companies-slider .company').each(function(index, el) {
			$(el).height( maxHeight );
		});
	}
	$('.companies-slider').on('init breakpoint', function(event, slick, currentSlide, nextSlide) {
		$('.companies-slider .company').css('height','auto');
		updateMaxHeight();
	});

	$('.companies-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: false,
		arrows: false,
		mobileFirst: true,
		responsive: [
 			{
				breakpoint: 1200,
				settings: "unslick",
 			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 4
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 2
				}
			}
		]
	})

})(jQuery);